import getDateIntervall from './getDateIntervall.jsx'
import getPeriodeStartDate from './getPeriodeStartDate.jsx'
import getPeriodeEndDate from './getPeriodeEndDate.jsx'
import naturalCompare from './naturalCompareStrings.jsx'
import setMomentDateObjZero from './setMomentDateObjZero.js'
import getFirstCurrentPerformance from './getFirstCurrentPerformance.js'
import getMomentDateObj from './getMomentDateObj.js'
import getDayKey from './getDayKey.js'
import isCurrentPerformance from './isCurrentPerformance.js'

const getPerformancesIntervallByTheatre = (performances, today, dateNow, timezone, filter = null) => {
    let dayIntervall = {}
    let theatres = {}
    let currentPeriodeStartDate
    let currentPeriodeEndDate

    if(filter && filter.time) {
        if(filter.time === 'week') {
            currentPeriodeStartDate = today
            currentPeriodeEndDate = getPeriodeEndDate(currentPeriodeStartDate, 6)
        }
    } else {
        currentPeriodeStartDate = getPeriodeStartDate(today)
        currentPeriodeEndDate = getPeriodeEndDate(currentPeriodeStartDate, 7)
    }

    if(currentPeriodeStartDate && currentPeriodeEndDate) {
        const firstCurrentPerformance = getFirstCurrentPerformance(today, performances, timezone)

        if(!firstCurrentPerformance) {
            return false
        }

        const firstcurrentPerformanceDate = setMomentDateObjZero(getMomentDateObj(firstCurrentPerformance.timeUtc, timezone))

        if(firstcurrentPerformanceDate.isSameOrBefore(currentPeriodeEndDate)) {
            dayIntervall = getDateIntervall(today, currentPeriodeEndDate)
        }
    }

    performances.map(performance => {
        const { timeUtc, attributes, theatreID, theatreName } = performance
        const attributesWithoutDigital = _.reject(attributes, attr => {
            return attr.id === 'digital'
        })

        const technologyAttributesSorted = attributesWithoutDigital.sort((a, b) => naturalCompare(a.name, b.name))
        const performanceDate = getMomentDateObj(timeUtc, timezone)
        const key = getDayKey(performanceDate)
        const theatreKeys = [theatreID]
        
        technologyAttributesSorted && technologyAttributesSorted.map(attribute => {
            const attributeIdWithoutSpace = attribute.id.trim();
            theatreKeys.push(attributeIdWithoutSpace)
        })

        const theatreKey = theatreKeys.join('-')

        if(isCurrentPerformance(dateNow, performanceDate)) {
            if(!theatres.hasOwnProperty(theatreKey)) {
                theatres[theatreKey] = {
                    theatreID: theatreID,
                    name: theatreName,
                    attributes: attributes,
                    dayIntervall: {}
                }
            }

            dayIntervall[key] = [true]

            if(theatres[theatreKey].dayIntervall.hasOwnProperty(key)) {
                theatres[theatreKey].dayIntervall[key].push(performance)
            } else {
                theatres[theatreKey].dayIntervall[key] = [performance]
            }
        }
    })

    const ObjectKeysDayIntervall = Object.keys(dayIntervall)

    return {
        dayIntervallObject: dayIntervall,
        dayIntervallKeys: ObjectKeysDayIntervall,
        theatreObjects: theatres
    }
}

export default getPerformancesIntervallByTheatre 